import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { TabBar, TabItem } from '../components';

const LandscapeProjectsEditProjectsGeneralInformationTemplate: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, projectId } = useParams();
  return (
    <div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem
          title="Lead Partners"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/general-information`}
        />
        <TabItem
          title="Image Gallery"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/general-information/image-gallery`}
        />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default LandscapeProjectsEditProjectsGeneralInformationTemplate;
